// extracted by mini-css-extract-plugin
export var editor = "_2n-0";
export var flowSidebar = "_54-2";